<template>
  <div style="height: 100%" class="member-nav border-r border-gray-300 border-solid">
    <div class="w-full text-center">
      <a-avatar :size="80">{{ userInfo.name.substring(0, 1) }}</a-avatar>
    </div>
    <div class="py-4 text-center left-8">{{ userInfo.name }}</div>
    <a-menu :selectedKeys="selectedKeys" style="width: 128px" @click="menuClick">
      <a-menu-item :key="5" v-if="canViewOrderList"
        >保函订单</a-menu-item
      >
        <a-menu-item :key="9" v-if="showTeamPerformance">团队业绩</a-menu-item>
       <a-menu-item :key="2">我的信息</a-menu-item>
    
    </a-menu>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import permission from '@/utils/permission';
  import { teamPerformanceVisible } from '@/api/business';
  export default {
    props: {
      selectedKeys: Array,
    },
    data() {
      return {
        showTeamPerformance: false,
      };
    },
    computed: {
      ...mapState('user', ['userInfo']),
      canViewOrderList() {
        return !!(this.userInfo && this.userInfo.id && !this.userInfo.is_black_user);
      },
    },
    activated() {
      this.loadTeamPerformanceVisible();
    },
    watch: {
      'userInfo.id'() {
        this.showTeamPerformance = false;
        this.loadTeamPerformanceVisible();
      },
    },
    methods: {
      permission,
      async loadTeamPerformanceVisible() {
        if (!this.userInfo || !this.userInfo.id) {
          this.showTeamPerformance = false;
          return;
        }
        const userID = this.userInfo.id;
        try {
          const res = await teamPerformanceVisible();
          if (userID !== this.userInfo.id) return;
          this.showTeamPerformance = !!res.visible;
        } catch (e) {
          if (userID !== this.userInfo.id) return;
          this.showTeamPerformance = false;
        }
      },
      menuClick({ key }) {
        switch (key) {
          case 2:
            this.$router.push('/admin/info');
            break;
          case 5:
            this.$router.push('/admin/p_contract');
            break;
          case 9:
            this.$router.push('/admin/team_performance');
            break;
        }
      },
    },
  };
</script>
